<template>
  <div class="story-reel-container">
    <div v-for="user in users" :key="user.id" class="story-item" @click="$emit('view-story', user.id)">
      <div class="story-ring" :class="{ new: user.hasNewStory, self: user.id === 'you' }">
        <v-avatar size="64">
          <img :src="user.bild" :alt="user.vorname" />
        </v-avatar>
        <v-icon v-if="user.id === 'you'" class="story-add-icon" dark>mdi-plus-circle</v-icon>
      </div>
      <span class="caption mt-1 d-block text-center white--text">{{ user.vorname }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    users: { type: Array, required: true },
  },
}
</script>

<style scoped>
.story-reel-container {
  display: flex;
  overflow-x: auto;
  padding: 8px 0;
  /* Scrollbar verstecken für einen cleanen Look */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.story-reel-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}
.story-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 8px;
  cursor: pointer;
  flex-shrink: 0;
}
.story-ring {
  border-radius: 50%;
  padding: 3px;
  position: relative;
  background: #333; /* Standard-Ring für gesehene Stories */
}
.story-ring.new {
  /* Der coole Instagram-Gradient */
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
}
.story-add-icon {
  position: absolute;
  bottom: 0;
  right: 0;
  background: #121212;
  border-radius: 50%;
}
</style>
